module.exports = __webpack_public_path__ + "assets/img/typeIcon-3.739c2267.svg";